import React, { Component } from "react";
import { getMessage } from "CONFIG/i18n";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import moment from 'moment';
import Pagination from "react-js-pagination";
import { withOrientationChange, isMobileOnly } from "react-device-detect";
import { Input, Button } from "reactstrap";

import { getBootstrapTableOptions, getPhoneNumberWithoutCountryCode } from "UTILS/Utility";
// ASSETS
import icBack from "ASSETS/Images/back.svg";
import icEclipse from "ASSETS/Images/ic_eclipse.svg";
import icCheck from "ASSETS/Images/ic_check.svg";
import icHistory from "ASSETS/Images/menu_icons/icon_history.svg";
import icCheckMark from "ASSETS/Images/check.svg";

// UTILS
import { PAGE_COUNT } from "UTILS/Constants";

// STYLESHEET
import "./TrailHistory.less";

class TrailHistory extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedSessionId: "",
      searchKey: this.props.trailHistoryData.searchKey,
      displayPage: this.props.trailHistoryData.displayPage + 1,
      sessionListPageSize: Number(this.props.trailHistoryData.sessionListPageSize),
      buttonDisabled: false,
    };
  }

  backYesHandle = () => {
    this.props.setTrailHistoryData("", 0, 10);
    this.props.backToMenu();
  }

  selectRow = (cell, row) => {
    return (
      row.sessionKey === this.state.selectedSessionId ?
        <img src={icCheck} /> : <img src={icEclipse} />
    );
  }

  holdingDate = (cell, row) => {
    return (
      <div className="d-flex flex-column">
        <span>{moment(row.startTime).format("YYYY/MM/DD")}</span>
        <span>
          {moment(row.startTime).format("HH:mm") + " - " + moment(row.endTime).format("HH:mm")}
        </span>
      </div>
    );
  }

  onRowSelect = (row, isSelected, e) => {
    this.setState({
      selectedSessionId: this.state.selectedSessionId !== row.sessionKey ?
        row.sessionKey : ""
    });
  }

  inviteeFormat = (cell, row) => {
    return (
      this.state.selectedSessionId !== row.sessionKey ?
        <span className="text-wrap text-truncate w-100">
          {row.invitees[0] && getPhoneNumberWithoutCountryCode(row.invitees[0])}
        </span> : (
          <div className="d-flex flex-column">
            {
              row.invitees.map((invitee, index) => (
                <span className="text-wrap text-truncate w-100" key={index}>
                  {getPhoneNumberWithoutCountryCode(invitee)}
                </span>
              ))
            }
          </div>
        )
    );
  }

  isRecordingFormat = (cell, row) => {
    return (
      row.isRecording ? <img
        src={icCheckMark}
        className="recordingCheckImg"
      /> : null
    )
  }

  changePage = (displayPage) => {
    this.state.displayPage !== displayPage &&
    this.setState({ displayPage },
      () => this.getPastSessionsList());
  }

  changePageCount = (event) => {
    this.setState({ sessionListPageSize: Number(event.target.value), displayPage: 1 },
      () => this.getPastSessionsList());
  }

  setValue = (e) => {
    this.setState({ searchKey: e.target.value });
  }

  search  = async () => {
    try {
      this.setState({ buttonDisabled: true});
      const value = this.state.searchKey;
      await this.setState({ searchKey: value, displayPage: 1 });
      await this.getPastSessionsList();
    } catch (error) {
      console.error("検索中にエラーが発生しました:", error);
    } finally {
      this.setState({ buttonDisabled: false });
    }
  }

  getPastSessionsList = () => {
    this.props.getPastSessionsList(
      this.state.sessionListPageSize,
      this.state.displayPage - 1,
      this.state.searchKey ?
        this.state.searchKey :
        undefined
    );
    const tableData = document.querySelector("#trailHistory .react-bs-container-body");
    tableData.scrollTop = 0;
  }

  inviteeAndTitleFormat = (cell, row) => {
    return (
      <>
        {this.state.selectedSessionId !== row.sessionKey ?
          <span className="text-wrap text-truncate w-100">
            {row.invitees[0] && getPhoneNumberWithoutCountryCode(row.invitees[0])}
          </span> :
          <div className="d-flex flex-column">{
            row.invitees.map((invitee, index) => (
              <span className="text-wrap text-truncate w-100" key={index}>
                {getPhoneNumberWithoutCountryCode(invitee)}
              </span>
            ))
          }
          </div>}
        <br />
        <span>{row.sessionName}</span>
        {row.isRecording ?
          <>
            <br />
            <span>
              <img src={icCheckMark} className="recordingCheckImg" />
            </span>
          </> : null
        }
      </>
    );
  }

  allFormat = (cell, row) => {
    return (
      <>
        <div className="d-flex flex-column">
          <span>{moment(row.startTime).format("YYYY/MM/DD")}</span>
          <span>
            {moment(row.startTime).format("HH:mm") + " - " + moment(row.endTime).format("HH:mm")}
          </span>
        </div>
        {this.state.selectedSessionId !== row.sessionKey ?
          <span className="text-wrap text-truncate w-100">
            {row.invitees[0] && getPhoneNumberWithoutCountryCode(row.invitees[0])}
          </span> :
          <div className="d-flex flex-column">{
            row.invitees.map((invitee, index) => (
              <span className="text-wrap text-truncate w-100" key={index}>
                {getPhoneNumberWithoutCountryCode(invitee)}
              </span>
            ))
          }
          </div>}
        <div><span>{row.sessionName}</span></div>
        {row.isRecording ?
          <div>
            <span>
              <img src={icCheckMark} className="recordingCheckImg" />
            </span>
          </div> : null
        }
      </>
    );
  }

  render() {
    const selectRowProp = {
      mode: 'radio',
      clickToSelect: true,
      hideSelectColumn: true,
      onSelect: this.onRowSelect,
      bgColor: "#FFF5E6"
    };
    return (
      <>
        <div className="col-xl-2 col-12 d-flex align-items-center backBtn pl-3 pt-2">
          <img src={icBack} className="pr-2 cursorPointer" onClick={this.backYesHandle}/>
          <span className="cursorPointer" onClick={this.backYesHandle}>{getMessage("BACK_TO_MENU")}</span>
        </div>
        <div className="container trailHistory">
          <div className="col-12 col-xl-6 offset-xl-3 d-flex justify-content-center">
            <div className="col-5 col-sm-3 p-0 d-flex flex-column">
              <div className="row">
                <div className="col-sm-12 text-center">
                  <img
                    src={icHistory}
                    className="img-fluid session-img createSessionImage"
                    alt="Start Session"
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12 text-center pb-4">
              <span className="sessionMenuTitle">{getMessage("TRAIL_HISTORY")}</span>
            </div>
          </div>
          <div className="trailHistoryContainer pt-3 mx-xl-5">
            <div className="d-flex justify-content-center">
              <div className="col-9 col-xl-7 d-flex justify-content-center">
                <input
                  className="formControl form-control border"
                  value={this.state.searchKey}
                  placeholder={getMessage("SEARCH_TRAIL_HISTORY_PLACEHOLDER")}
                  onChange={this.setValue}
                  maxLength={20}
                />
              </div>
              <Button
                className={"customBtn btn btn-secondary"}
                onClick={this.search}
                disabled={this.state.buttonDisabled}
              >
                {getMessage("SEARCH")}
              </Button>
            </div>
            <div className="d-flex justify-content-center">
              <div className="col-xl-9 d-flex justify-content-center" id="trailHistory">
                <BootstrapTable
                  data={this.props.pastSessionsDetails.sessions}
                  keyField="sessionKey"
                  id="trailHistoryTable"
                  containerClass="trailHistoryContainer p-3"
                  bordered={false}
                  options={getBootstrapTableOptions()}
                  selectRow={selectRowProp}
                  maxHeight="450px"
                  printable
                >
                  {/* column hidden always */}
                  <TableHeaderColumn
                    dataField="sessionKey"
                    searchable={false}
                    hidden
                  >
                    {getMessage("SESSION_KEY")}
                  </TableHeaderColumn>

                  {/* column visible for all devices */}
                  <TableHeaderColumn
                    dataField="sessionKey"
                    searchable={false}
                    dataFormat={this.selectRow}
                    width={isMobileOnly ? "11%" : "8%"}
                    dataAlign="right"
                    columnClassName="hide-ellipsis"
                  />

                  {/* column visible for desktop, tablet and horizontal mobile */}
                  <TableHeaderColumn
                    dataField="holding_date"
                    dataFormat={this.holdingDate}
                    width={this.props.isLandscape ? "25%" : "20%"}
                    hidden={isMobileOnly && !this.props.isLandscape}
                    dataAlign="left"
                  >
                    {getMessage("HOLDING_DATE")}
                  </TableHeaderColumn>

                  {/* Hide this for inbound cobrowse */}
                  {/* column hidden only for mobile */}
                  {/* <TableHeaderColumn
                    dataFormat={this.inviteeFormat}
                    dataField="invitees"
                    dataAlign="left"
                    hidden={isMobileOnly}
                  >
                    {getMessage("GUEST_CONTACT")}
                  </TableHeaderColumn> */}

                  {/* column hidden only for mobile */}
                  <TableHeaderColumn
                    className="p-0"
                    dataField="sessionName"
                    hidden={isMobileOnly}
                  >
                    {getMessage("MEETING_TITLE")}
                  </TableHeaderColumn>

                  {/* column hidden only for mobile */}
                  <TableHeaderColumn
                    className="p-0"
                    dataField="isRecording"
                    hidden={isMobileOnly}
                    width={isMobileOnly ? "0%" : "15%"}
                    dataFormat={this.isRecordingFormat}
                  >
                    {getMessage("AUDIO_VIDEO_RECORDING")}
                  </TableHeaderColumn>

                  {/* Column is visible for horizontal mobile */}
                  <TableHeaderColumn
                    dataField="inviteesAndTitle"
                    dataAlign="left"
                    hidden={!this.props.isLandscape || !isMobileOnly}
                    width={this.props.isLandscape ? "67%" : "0%"}
                    dataFormat={this.inviteeAndTitleFormat}
                  >
                    {/* {getMessage("GUEST_CONTACT")}<br /> */}{getMessage("MEETING_TITLE")}<br />{getMessage("AUDIO_VIDEO_RECORDING")}
                  </TableHeaderColumn>

                  {/* Column is hidden for desktop and tablet and horizontal mobile */}
                  <TableHeaderColumn
                    dataField="all"
                    dataAlign="left"
                    hidden={!isMobileOnly}
                    dataFormat={this.allFormat}
                  >
                    {getMessage("HOLDING_DATE")}<br />{/* {getMessage("GUEST_CONTACT")}<br /> */}{getMessage("MEETING_TITLE")}<br />{getMessage("AUDIO_VIDEO_RECORDING")}
                  </TableHeaderColumn>
                </BootstrapTable>
              </div>
            </div>
          </div>

          { this.props.pastSessionsDetails.sessions && this.props.totalSessions > 0 &&
          <div className={this.props.isLandscape ? "col-xl-8 offset-xl-2 d-flex px-md-auto px-0 pt-2 pb-auto pb-2 justify-content-between" : "col-xl-8 offset-xl-2 d-md-flex px-md-auto px-0 pt-2 pb-auto pb-2 justify-content-between"}>
            <div>
              {getMessage("PAGINATION_TOTAL_ENTRIES",
                { from: (this.state.displayPage - 1) * this.state.sessionListPageSize + 1,
                  to: (this.state.displayPage - 1) * this.state.sessionListPageSize
                  + this.props.pastSessionsDetails.sessions.length,
                  totalCount: this.props.totalSessions })}
            </div>
            {this.props.totalSessions > this.state.sessionListPageSize &&
            <Pagination
              activePage={this.state.displayPage}
              itemsCountPerPage={this.state.sessionListPageSize}
              totalItemsCount={this.props.totalSessions}
              pageRangeDisplayed={3}
              onChange={this.changePage}
              itemClass="page-item"
              linkClass="page-link"
              innerClass={this.props.isLandscape ? "pagination pr-4" : "pagination"}
            />}
            {/* when in mobile vertical width needs to be reduced to 25% from 100% */}
            <div className={isMobileOnly && !this.props.isLandscape ? "sessionCount w-25" : "sessionCount"}>
              <Input type="select" className="inputFormControl form-control border" onChange={this.changePageCount} value={this.state.sessionListPageSize}>
                {
                  PAGE_COUNT.map((count) => (
                    <option key={count} value={count}>
                      {count}
                    </option>
                  ))
                }
              </Input>
            </div>
          </div>}
        </div>
      </>
    );
  }
}

export default withOrientationChange(TrailHistory);
